module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_5010.51479381.png";